import confetti from "canvas-confetti";

// Confetti celebration for streak milestones
export const triggerConfetti = (intensity = 'medium') => {
  const configs = {
    light: { particleCount: 50, spread: 60 },
    medium: { particleCount: 100, spread: 70 },
    heavy: { particleCount: 200, spread: 100 }
  };
  const config = configs[intensity] || configs.medium;
  
  // Fire from both sides - Blue theme colors
  confetti({
    ...config,
    origin: { x: 0.1, y: 0.6 },
    colors: ['#7dd3fc', '#38bdf8', '#0ea5e9', '#ffffff', '#fbbf24']
  });
  confetti({
    ...config,
    origin: { x: 0.9, y: 0.6 },
    colors: ['#7dd3fc', '#38bdf8', '#0ea5e9', '#ffffff', '#fbbf24']
  });
};

// Streak Emoji basierend auf der Anzahl - 🌱 Serie
export const getStreakEmoji = (streak) => {
  if (streak >= 30) return "🏆";
  if (streak >= 14) return "⭐";
  if (streak >= 7) return "🌱";
  if (streak >= 3) return "🌱";
  return "🌱";
};

// Badges für Meilensteine
export const getBadges = (totalCompleted, t) => {
  const badges = [];
  if (totalCompleted >= 7) badges.push({ icon: "🔥", label: t.badge7Days, achieved: true });
  if (totalCompleted >= 30) badges.push({ icon: "⭐", label: t.badge30Days, achieved: true });
  if (totalCompleted >= 100) badges.push({ icon: "🏆", label: t.badge100Deeds, achieved: true });
  return badges;
};
